// extracted by mini-css-extract-plugin
module.exports = {"facebookBtn":"styles_facebookBtn__hRfzS","fbIcon":"styles_fbIcon__mrLg5","facebookBtnText":"styles_facebookBtnText__n_yzE"};